import React, { createContext, FunctionComponent, PropsWithChildren, useMemo } from "react";

import { TypedObject } from "@multiweb/types/react";
import { DraggableItem } from "./types";

type DraggableItemsContextType = {
    readonly getDraggableItem: (id: string) => DraggableItem | undefined;
};

export const DraggableItemsContext = createContext<DraggableItemsContextType | null>(null);

type DraggableItemsContextProviderProps = PropsWithChildren<{
    readonly items: TypedObject<DraggableItem>;
}>;

export const DraggableItemsContextProvider: FunctionComponent<DraggableItemsContextProviderProps> = ({ items, children }) => {
    const value = useMemo<DraggableItemsContextType>(() => ({
        getDraggableItem: (itemId: string) => items[itemId],
    }), [items]);

    return (
        <DraggableItemsContext.Provider value={value}>
            {children}
        </DraggableItemsContext.Provider>
    );
};
